import { checkInjectAssistantJs } from './assistantMode'
import { customMerge } from './utils'

export async function mountCommentatorUIWebComponent(
  data: any,
  playerId?: string,
  displayCommentary?: boolean
) {
  await checkInjectAssistantJs()

  const commentatorId = 'commentator-host'

  let defaultParams: any = {}
  const storedParams = localStorage.getItem('commentaryParams')
  if (storedParams) {
    try {
      defaultParams = JSON.parse(storedParams)
    } catch (error) {
      console.error('Error parsing stored data:', error)
    }
  }

  // temp implementation to get hero_index, need to find better way to implement this
  let hero_index = null
  const players = data.players?.map((p: any, i: number) => {
    if (p.hole_cards !== null) {
      hero_index = p.seat_no + 1
    }

    return {
      seat_no: typeof p.seat_no === 'number' ? p.seat_no + 1 : null,
      stack: p.stack,
      uid: String(typeof p.seat_no === 'number' ? p.seat_no + 1 : i),
      hole_cards: p.hole_cards,
      position: p.position,
      win_amount: p.win_amount,
      rake_amount: p.rake_amount,
      platform: p.platform,
      name: p.name || p.uid + i
    }
  })

  const gameData = {
    gameuuid: data.gameuuid,
    game_type: data.game_type,
    game_mode_code: data.game_mode_code,
    players,
    actions: {
      entries:
        data.actions?.entries?.map((e: any) => ({
          action: e.action,
          amount: e.amount || null,
          pot_size: e.pot_size,
          player_position: e.player_position,
          seat_no: typeof e.seat_no === 'number' ? e.seat_no + 1 : null,
          action_time: e.action_time
        })) || [],
      pot_sizings: data.actions?.pot_sizings || false,
      big_blind_size: data.actions?.big_blind_size || null,
      big_blind_sizings: data.actions?.big_blind_sizings || false
    },
    big_blind: data.big_blind,
    ante: data.ante,
    dealer_seat: data.dealer_seat,
    sb_seat: data.sb_seat,
    bb_seat: data.bb_seat,
    game_type_code: data.game_type_code,
    game_group: data.game_group,
    // TODO: uncomment later
    // date: data.date,
    // passed date as null because one of the APIs in `commentary_with_rl` is responding with error
    date: null,
    roomid: data.roomid,
    straddle_seat: data.straddle_seat,
    flop_pot: data.flop_pot,
    turn_pot: data.turn_pot,
    river_pot: data.river_pot,
    final_pot: data.final_pot,
    post_seats: data.post_seats,
    currency: data.currency
  }

  const params = customMerge(gameData, defaultParams?.game_hand || {})

  if (!document.getElementById(commentatorId)) {
    const commentator = document.createElement('commentator-host')
    commentator.id = commentatorId
    document.body.appendChild(commentator)
  }

  const commentator = document.getElementById(commentatorId)!

  commentator.setAttribute(
    'hand',
    JSON.stringify({
      playerId,
      game_hand: params,
      personality: defaultParams?.personality || 'normal',
      language: defaultParams?.language || 'english',
      output_length: defaultParams?.output_length || '60',
      hero_index,
      displayCommentary
    })
  )

  return {
    heroIndex: hero_index,
    players
  }
}

export function unmountCommentatorUIWebComponent() {
  const commentator = document.getElementById('commentator-host')

  if (commentator) {
    commentator.remove()
  }
}
